const Grid2 = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.short,
      }),
    }),
  },
};

export default Grid2;
